import BaseModel from '../core/BaseModel'
//import UserModel from '@/models/UserModel'
export default class LangModel extends BaseModel {

    constructor() {
        super({
                name: "lang",
                tableName: 'lang',
                label: "lang",
                display_key: 'name'
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                name: {
                    name: 'name',
                    type: "String",
                    label: 'Name',
                    width: 15,
                    filter: {type: 'input', match: 'contains'},
                },
                detail_get: {
                    refs:  ' iso_code  ',
                    display: false
                },
            })
    }

}